module.exports = __webpack_public_path__ + "img/btn_TA_hover.cdda01e8.png";